module.exports = __webpack_public_path__ + "img/solar-farm.b08cf134.png";